import { PathRouteProps } from "react-router-dom";
import SystemPayRoutes from "../utils/constants/Routes";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import Reports from "../pages/Reports";
import ReportDetails from "../pages/ReportDetails";
import CategoryPage from "../pages/Category";
import UserRoleConfigurationPage from "../pages/UserRoleConfiguration";
import Users from "../pages/Users";
import NotFound from "../pages/NotFound";
import { permissions } from "../utils/constants/permissions";
import ActivityLogs from "../pages/ActivityLogs";
import EmailLogs from "../pages/EmailLogs";
import DeleteReason from "../pages/DeleteReason";
import EmailTemplate from "../pages/EmailTemplates";
import FoundReportDetails from "../pages/FoundReportDetails";
import PaymentLogs from "../pages/PaymentLogs";
import Profile from "../pages/Profile";
import Setting from "../pages/Settings";
import PermissionKey from "../pages/PermissionKey";
import Whiteboard from "../pages/Whiteboard";
import EstablishmentTypeAreYou from "../pages/EstablishmentType/ImprovedIndex";
import PricingPlanFeatures from "../pages/PricingPlan";
import Customers from "../pages/Customers";
import Reviews from "../pages/Reviews";
import ConversionTracking from "../pages/ConversionTracking";

export const routeMap: Array<
  PathRouteProps & { private?: boolean; separate?: boolean; requiredPermission?: string }
> = [
    {
      path: SystemPayRoutes.base,
      element: <Login />,
      private: false,
    },
    {
      path: SystemPayRoutes.signIn,
      element: <Login />,
      private: false,
    },
    {
      path: SystemPayRoutes.forgotPassword,
      element: <ForgotPassword />,
      private: false,
    },
    {
      path: SystemPayRoutes.reports,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/urgent`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/open`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/pending`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/review`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/in-process`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/lf-notified`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/unpaid`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/drafts`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/not-paid`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/draft-incomplete`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/draft-complete`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/overdue`,
      element: <Reports />,
      private: true,
    },
    {
      path: `${SystemPayRoutes.reports}/deleted`,
      element: <Reports />,
      private: true,
    },
    {
        path: SystemPayRoutes.customers,
        element: <Customers />,
        private: true,
    },
    {
      path: SystemPayRoutes.reportsType,
      element: <Reports />,
      private: true,
    },
    {
      path: SystemPayRoutes.report,
      element: <ReportDetails />,
      private: true,
    },
    {
      path: SystemPayRoutes.foundReport,
      element: <FoundReportDetails />,
      private: true,
    },
    {
      path: SystemPayRoutes.category,
      element: <CategoryPage />,
      private: true,
      requiredPermission: permissions.IsCategoryMenuVisible,
    },
    {
        path: SystemPayRoutes.pricingPlan,
        element: <PricingPlanFeatures />,
        private: true,
        requiredPermission: permissions.IsPricingPlanMenuVisible,
    },
    {
      path: SystemPayRoutes.userRoleConfiguration,
      element: <UserRoleConfigurationPage />,
      private: true,
      requiredPermission: permissions.IsUserRoleConfigMenuVisible,
    },
    {
      path: SystemPayRoutes.Users,
      element: <Users />,
      private: true,
      requiredPermission: permissions.IsUserMenuVisible,
    },
    {
      path: SystemPayRoutes.activityLogs,
      element: <ActivityLogs />,
      private: true,
    },
    {
      path: SystemPayRoutes.emailLogs,
      element: <EmailLogs />,
      private: true,
    },
    {
      path: SystemPayRoutes.paymentLogs,
      element: <PaymentLogs />,
      private: true,
      requiredPermission: permissions.IsPaymentLogAllowed,
    },
    {
        path: SystemPayRoutes.establishmentType,
        element: <EstablishmentTypeAreYou />,
        private: true,
        requiredPermission: permissions.IsEstablishmentTypeMenuVisible,
    },
    {
      path: SystemPayRoutes.deleteReason,
      element: <DeleteReason />,
      private: true,
      requiredPermission: permissions.IsDeleteLostReasonMenuVisible,
    },
    {
      path: SystemPayRoutes.mailTemplate,
      element: <EmailTemplate />,
      private: true,
      requiredPermission: permissions.IsEmailTemplateMenuVisible,
    },
    {
      path: SystemPayRoutes.profile,
      element: <Profile />,
      private: true,
    },
    {
      path: SystemPayRoutes.keysAndSettings,
      element: <Setting />,
      private: true,
      requiredPermission: permissions.IsKeyAndSettingMenuVisible,
    },
    {
      path: SystemPayRoutes.permissionKey,
      element: <PermissionKey />,
      private: true,
      requiredPermission: permissions.IsPermissionConfigMenuVisible,
    },
    {
      //Whiteboard
      path: SystemPayRoutes.whiteboard,
      element: <Whiteboard />,
      private: true,
      requiredPermission: permissions.IsWhiteboardMenuVisible,
    },
    {
      path: SystemPayRoutes.reviews,
      element: <Reviews />,
      private: true,
    },
    {
      path: SystemPayRoutes.conversionTracking,
      element: <ConversionTracking />,
      private: true,
      requiredPermission: permissions.IsConversionTrackingMenuVisible,
    },
    {
      path: "*",
      element: <NotFound />,
      separate: true,
    },
  ];
